import {
  Box,
  BoxProps,
  Button,
  ButtonProps,
  Flex,
  FlexProps,
  Heading,
  HeadingProps,
  SimpleGrid,
  SimpleGridProps,
  VStack
} from '@chakra-ui/react'
import Link from 'next/link'
import {FaHeadset, FaSchool} from 'react-icons/fa'
import {GoFile} from 'react-icons/go'
import {FiArrowRight} from 'react-icons/fi'

import {space} from 'config/theme'

export default function ContactCards({...p}: SimpleGridProps) {
  return (
    <SimpleGrid
      columns={{base: 1, md: 2, xl: 3}}
      spacingX={space.md}
      spacingY={space.lg}
      {...p}
    >
      <SalesCard />
      <AcademicCard />
      <DocsCard />
    </SimpleGrid>
  )
}

export function DocsCard() {
  return (
    <ContactCard>
      <ContactCardIcon>
        <GoFile />
      </ContactCardIcon>
      <ContactCardTitle>Docs</ContactCardTitle>
      <ContactCardBody>
        Discover how Conveyal enables unique accessibility insights.
      </ContactCardBody>
      <Link href='https://docs.conveyal.com' passHref>
        <ContactCardButton>Visit Docs</ContactCardButton>
      </Link>
    </ContactCard>
  )
}

export function SalesCard() {
  return (
    <ContactCard>
      <ContactCardIcon>
        <FaHeadset />
      </ContactCardIcon>
      <ContactCardTitle>New users</ContactCardTitle>
      <ContactCardBody>
        We tailor Conveyal subscriptions for your team size and needs.
      </ContactCardBody>
      <Link href='/contact/new' passHref>
        <ContactCardButton>Get started</ContactCardButton>
      </Link>
    </ContactCard>
  )
}

export function AcademicCard() {
  return (
    <ContactCard>
      <ContactCardIcon>
        <FaSchool />
      </ContactCardIcon>
      <ContactCardTitle>Education & Research</ContactCardTitle>
      <ContactCardBody>
        We offer special subscriptions for educators and students.
      </ContactCardBody>
      <Link href='/research' passHref>
        <ContactCardButton>Learn more</ContactCardButton>
      </Link>
    </ContactCard>
  )
}

function ContactCard({children}: {children: JSX.Element[]}) {
  return (
    <VStack
      boxShadow='md'
      bg='white'
      pt={space.md}
      rounded='md'
      spacing={space.sm}
      maxWidth='290px'
    >
      {children}
    </VStack>
  )
}

function ContactCardTitle({children, ...p}: HeadingProps) {
  return (
    <Heading color='blue.800' size='md' {...p}>
      {children}
    </Heading>
  )
}

function ContactCardIcon({children, ...p}: FlexProps) {
  return (
    <Flex
      alignContent='center'
      fontSize='2.5rem'
      justify='center'
      bg='blue.500'
      color='white'
      lineHeight='5rem'
      pt='1.25rem'
      mx='auto'
      rounded='full'
      height='5rem'
      width='5rem'
      {...p}
    >
      {children}
    </Flex>
  )
}

function ContactCardBody({children, ...p}: BoxProps) {
  return (
    <Box color='gray.600' textAlign='center' px={2} {...p}>
      {children}
    </Box>
  )
}

function ContactCardButton({children, ...p}: ButtonProps) {
  return (
    <Button
      colorScheme='blue'
      isFullWidth
      rightIcon={<FiArrowRight />}
      size='lg'
      {...p}
    >
      {children}
    </Button>
  )
}
